import BaseModelInstance from './base.model'
import { PromotionCode as ModelDefinition } from './model-definitions'

class PromotionCode extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default PromotionCode
